import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import auth from 'utils/Auth';

const ProtectedRoutes = ({isChoiceOptional, isAuthRequired}) => {
  const token = auth.isHaveToken();
  const parameters = auth.getUserChoises();

  if(isAuthRequired && !token)
  {
    return <Navigate to={"/"} replace />;
  }

  if (!isAuthRequired && isChoiceOptional && (token && (!parameters?.deliveryType || !parameters?.neighbourhoodId || !parameters?.restaurantId || (parameters?.deliveryType == 2 && !parameters?.regionId))) ){
    return <Navigate to={"/uye-girisi"} replace />
  }

    if (!isChoiceOptional && (!parameters?.deliveryType || !parameters?.neighbourhoodId || !parameters?.restaurantId || (parameters?.deliveryType == 2 && !parameters?.regionId))){
      return <Navigate to={"/uye-girisi"} replace />
    }
  
    return <Outlet />;
};

export default ProtectedRoutes;